export default function sellerStateForm(Alpine) {
  Alpine.data("stateSearch", () => ({
    open: false,
    query: "",
    selected: null,
    states: [],
    highlighted: -1,

    init() {
      this.states = JSON.parse(this.$el.dataset.stateList || "[]");
    },

    get filtered() {
      if (!this.query) return this.states;
      const q = this.query.toLowerCase();
      return this.states.filter((s) => s.name.toLowerCase().includes(q));
    },

    pick(s) {
      this.selected = s;
      this.query = s.name;
      this.open = false;
      this.highlighted = -1;
    },

    move(delta) {
      const max = this.filtered.length - 1;
      if (max < 0) return;
      this.open = true;
      this.highlighted = Math.min(Math.max(this.highlighted + delta, 0), max);
    },

    choose() {
      if (this.highlighted >= 0) this.pick(this.filtered[this.highlighted]);
    },
  }));
}
